import { lazy } from 'react';

// ----------------------------------------------------------------------

const DistributorsSettingsPage = lazy(
  () =>
    import(
      /* webpackPreload: true */
      /* webpackChunkName: "DistributorsSettingsPage" */
      './DistributorsSettingsPage'
    ),
);

export default DistributorsSettingsPage;
